import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Cruzeiro de Despedida de Solteira em Vilamoura · Iate Privado · Morningstar";
const DESC = "Cruzeiro privado de despedida de solteira em Vilamoura no Morningstar — espumante, upgrades de DJ ou saxofonista, pôr-do-sol e paragens de mergulho. Até 18 pessoas, barco 100% privado.";
const PATH = "/pt/cruzeiro-despedida-solteira-vilamoura";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/cruzeiro-despedida-solteira-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Despedida de Solteira · Vilamoura · Algarve",
        title: "Cruzeiro de despedida de solteira em Vilamoura a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Um iate 100% privado, espumante à chegada, upgrades de DJ ou saxofone e um pôr-do-sol inesquecível. Até 18 pessoas, playlist personalizada.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Planear a despedida",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "despedida de solteira vilamoura, despedida solteira barco algarve, despedida solteira iate vilamoura, despedida solteira algarve",
      altPath: { en: "/vilamoura-hen-party-cruise", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Vilamoura Hen Party Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Despedida de Solteira Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});
